export const NAME = 'COUNTRIES';

export const citiesOfCountry = (store) =>
  store[NAME].citiesOfCountry?.data || [];
